import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    overlay: {
        pointerEvents: "none",
        position: "absolute",
        zIndex: 99995,
        bottom: 0,
        right: 0,
        left: 0,
        top: 0
    },
    container: {
        position: "absolute",
        display: "flex",
        zIndex: 99994,
        bottom: 0,
        right: 0,
        left: 0,
        top: 0
    },
    overlayContent: {
        position: "absolute",
        zIndex: 99996,
        bottom: 0,
        right: 0,
        left: 0,
        top: 0
    },
    content: {
        display: "contents",
        zIndex: 99997
    }
});
export default stylesheet;
